//[0]: DDMM,	[1]: DM,	[2]:D, 	[3]:M,	[4]: replacement part1, [5]: replacement part2, [6]: replacement]
export function getDateTranslation() {
  return [
    ['01.01.', '1.1.', '1', '1', 'prvního', 'ledna', 'prvního ledna'],
    ['02.01.', '2.1.', '2', '1', 'druhého', 'ledna', 'druhého ledna'],
    ['03.01.', '3.1.', '3', '1', 'třetího', 'ledna', 'třetího ledna'],
    ['04.01.', '4.1.', '4', '1', 'čtvrtého', 'ledna', 'čtvrtého ledna'],
    ['05.01.', '5.1.', '5', '1', 'pátého', 'ledna', 'pátého ledna'],
    ['06.01.', '6.1.', '6', '1', 'šestého', 'ledna', 'šestého ledna'],
    ['07.01.', '7.1.', '7', '1', 'sedmého', 'ledna', 'sedmého ledna'],
    ['08.01.', '8.1.', '8', '1', 'osmého', 'ledna', 'osmého ledna'],
    ['09.01.', '9.1.', '9', '1', 'devátého', 'ledna', 'devátého ledna'],
    ['10.01.', '10.1.', '10', '1', 'desátého', 'ledna', 'desátého ledna'],
    ['11.01.', '11.1.', '11', '1', 'jedenáctého', 'ledna', 'jedenáctého ledna'],
    ['12.01.', '12.1.', '12', '1', 'dvanáctého', 'ledna', 'dvanáctého ledna'],
    ['13.01.', '13.1.', '13', '1', 'třináctého', 'ledna', 'třináctého ledna'],
    ['14.01.', '14.1.', '14', '1', 'čtrnáctého', 'ledna', 'čtrnáctého ledna'],
    ['15.01.', '15.1.', '15', '1', 'patnáctého', 'ledna', 'patnáctého ledna'],
    ['16.01.', '16.1.', '16', '1', 'šestnáctého', 'ledna', 'šestnáctého ledna'],
    ['17.01.', '17.1.', '17', '1', 'sedmnáctého', 'ledna', 'sedmnáctého ledna'],
    ['18.01.', '18.1.', '18', '1', 'osmnáctého', 'ledna', 'osmnáctého ledna'],
    ['19.01.', '19.1.', '19', '1', 'devatenáctého', 'ledna', 'devatenáctého ledna'],
    ['20.01.', '20.1.', '20', '1', 'dvacátého', 'ledna', 'dvacátého ledna'],
    ['21.01.', '21.1.', '21', '1', 'dvacátéhoprvního', 'ledna', 'dvacátéhoprvního ledna'],
    ['22.01.', '22.1.', '22', '1', 'dvacátéhodruhého', 'ledna', 'dvacátéhodruhého ledna'],
    ['23.01.', '23.1.', '23', '1', 'dvacátéhotřetího', 'ledna', 'dvacátéhotřetího ledna'],
    ['24.01.', '24.1.', '24', '1', 'dvacátéhočtvrtého', 'ledna', 'dvacátéhočtvrtého ledna'],
    ['25.01.', '25.1.', '25', '1', 'dvacátéhopátého', 'ledna', 'dvacátéhopátého ledna'],
    ['26.01.', '26.1.', '26', '1', 'dvacátéhošestého', 'ledna', 'dvacátéhošestého ledna'],
    ['27.01.', '27.1.', '27', '1', 'dvacátéhosedmého', 'ledna', 'dvacátéhosedmého ledna'],
    ['28.01.', '28.1.', '28', '1', 'dvacátéhoosmého', 'ledna', 'dvacátéhoosmého ledna'],
    ['29.01.', '29.1.', '29', '1', 'dvacátéhodevátého', 'ledna', 'dvacátéhodevátého ledna'],
    ['30.01.', '30.1.', '30', '1', 'třicátého', 'ledna', 'třicátého ledna'],
    ['31.01.', '31.1.', '31', '1', 'třicátéhoprvního', 'ledna', 'třicátéhoprvního ledna'],
    ['01.02.', '1.2.', '1', '2', 'prvního', 'února', 'prvního února'],
    ['02.02.', '2.2.', '2', '2', 'druhého', 'února', 'druhého února'],
    ['03.02.', '3.2.', '3', '2', 'třetího', 'února', 'třetího února'],
    ['04.02.', '4.2.', '4', '2', 'čtvrtého', 'února', 'čtvrtého února'],
    ['05.02.', '5.2.', '5', '2', 'pátého', 'února', 'pátého února'],
    ['06.02.', '6.2.', '6', '2', 'šestého', 'února', 'šestého února'],
    ['07.02.', '7.2.', '7', '2', 'sedmého', 'února', 'sedmého února'],
    ['08.02.', '8.2.', '8', '2', 'osmého', 'února', 'osmého února'],
    ['09.02.', '9.2.', '9', '2', 'devátého', 'února', 'devátého února'],
    ['10.02.', '10.2.', '10', '2', 'desátého', 'února', 'desátého února'],
    ['11.02.', '11.2.', '11', '2', 'jedenáctého', 'února', 'jedenáctého února'],
    ['12.02.', '12.2.', '12', '2', 'dvanáctého', 'února', 'dvanáctého února'],
    ['13.02.', '13.2.', '13', '2', 'třináctého', 'února', 'třináctého února'],
    ['14.02.', '14.2.', '14', '2', 'čtrnáctého', 'února', 'čtrnáctého února'],
    ['15.02.', '15.2.', '15', '2', 'patnáctého', 'února', 'patnáctého února'],
    ['16.02.', '16.2.', '16', '2', 'šestnáctého', 'února', 'šestnáctého února'],
    ['17.02.', '17.2.', '17', '2', 'sedmnáctého', 'února', 'sedmnáctého února'],
    ['18.02.', '18.2.', '18', '2', 'osmnáctého', 'února', 'osmnáctého února'],
    ['19.02.', '19.2.', '19', '2', 'devatenáctého', 'února', 'devatenáctého února'],
    ['20.02.', '20.2.', '20', '2', 'dvacátého', 'února', 'dvacátého února'],
    ['21.02.', '21.2.', '21', '2', 'dvacátéhoprvního', 'února', 'dvacátéhoprvního února'],
    ['22.02.', '22.2.', '22', '2', 'dvacátéhodruhého', 'února', 'dvacátéhodruhého února'],
    ['23.02.', '23.2.', '23', '2', 'dvacátéhotřetího', 'února', 'dvacátéhotřetího února'],
    ['24.02.', '24.2.', '24', '2', 'dvacátéhočtvrtého', 'února', 'dvacátéhočtvrtého února'],
    ['25.02.', '25.2.', '25', '2', 'dvacátéhopátého', 'února', 'dvacátéhopátého února'],
    ['26.02.', '26.2.', '26', '2', 'dvacátéhošestého', 'února', 'dvacátéhošestého února'],
    ['27.02.', '27.2.', '27', '2', 'dvacátéhosedmého', 'února', 'dvacátéhosedmého února'],
    ['28.02.', '28.2.', '28', '2', 'dvacátéhoosmého', 'února', 'dvacátéhoosmého února'],
    ['29.02.', '29.2.', '29', '2', 'dvacátéhodevátého', 'února', 'dvacátéhodevátého února'],
    ['01.03.', '1.3.', '1', '3', 'prvního', 'března', 'prvního března'],
    ['02.03.', '2.3.', '2', '3', 'druhého', 'března', 'druhého března'],
    ['03.03.', '3.3.', '3', '3', 'třetího', 'března', 'třetího března'],
    ['04.03.', '4.3.', '4', '3', 'čtvrtého', 'března', 'čtvrtého března'],
    ['05.03.', '5.3.', '5', '3', 'pátého', 'března', 'pátého března'],
    ['06.03.', '6.3.', '6', '3', 'šestého', 'března', 'šestého března'],
    ['07.03.', '7.3.', '7', '3', 'sedmého', 'března', 'sedmého března'],
    ['08.03.', '8.3.', '8', '3', 'osmého', 'března', 'osmého března'],
    ['09.03.', '9.3.', '9', '3', 'devátého', 'března', 'devátého března'],
    ['10.03.', '10.3.', '10', '3', 'desátého', 'března', 'desátého března'],
    ['11.03.', '11.3.', '11', '3', 'jedenáctého', 'března', 'jedenáctého března'],
    ['12.03.', '12.3.', '12', '3', 'dvanáctého', 'března', 'dvanáctého března'],
    ['13.03.', '13.3.', '13', '3', 'třináctého', 'března', 'třináctého března'],
    ['14.03.', '14.3.', '14', '3', 'čtrnáctého', 'března', 'čtrnáctého března'],
    ['15.03.', '15.3.', '15', '3', 'patnáctého', 'března', 'patnáctého března'],
    ['16.03.', '16.3.', '16', '3', 'šestnáctého', 'března', 'šestnáctého března'],
    ['17.03.', '17.3.', '17', '3', 'sedmnáctého', 'března', 'sedmnáctého března'],
    ['18.03.', '18.3.', '18', '3', 'osmnáctého', 'března', 'osmnáctého března'],
    ['19.03.', '19.3.', '19', '3', 'devatenáctého', 'března', 'devatenáctého března'],
    ['20.03.', '20.3.', '20', '3', 'dvacátého', 'března', 'dvacátého března'],
    ['21.03.', '21.3.', '21', '3', 'dvacátéhoprvního', 'března', 'dvacátéhoprvního března'],
    ['22.03.', '22.3.', '22', '3', 'dvacátéhodruhého', 'března', 'dvacátéhodruhého března'],
    ['23.03.', '23.3.', '23', '3', 'dvacátéhotřetího', 'března', 'dvacátéhotřetího března'],
    ['24.03.', '24.3.', '24', '3', 'dvacátéhočtvrtého', 'března', 'dvacátéhočtvrtého března'],
    ['25.03.', '25.3.', '25', '3', 'dvacátéhopátého', 'března', 'dvacátéhopátého března'],
    ['26.03.', '26.3.', '26', '3', 'dvacátéhošestého', 'března', 'dvacátéhošestého března'],
    ['27.03.', '27.3.', '27', '3', 'dvacátéhosedmého', 'března', 'dvacátéhosedmého března'],
    ['28.03.', '28.3.', '28', '3', 'dvacátéhoosmého', 'března', 'dvacátéhoosmého března'],
    ['29.03.', '29.3.', '29', '3', 'dvacátéhodevátého', 'března', 'dvacátéhodevátého března'],
    ['30.03.', '30.3.', '30', '3', 'třicátého', 'března', 'třicátého března'],
    ['31.03.', '31.3.', '31', '3', 'třicátéhoprvního', 'března', 'třicátéhoprvního března'],
    ['01.04.', '1.4.', '1', '4', 'prvního', 'dubna', 'prvního dubna'],
    ['02.04.', '2.4.', '2', '4', 'druhého', 'dubna', 'druhého dubna'],
    ['03.04.', '3.4.', '3', '4', 'třetího', 'dubna', 'třetího dubna'],
    ['04.04.', '4.4.', '4', '4', 'čtvrtého', 'dubna', 'čtvrtého dubna'],
    ['05.04.', '5.4.', '5', '4', 'pátého', 'dubna', 'pátého dubna'],
    ['06.04.', '6.4.', '6', '4', 'šestého', 'dubna', 'šestého dubna'],
    ['07.04.', '7.4.', '7', '4', 'sedmého', 'dubna', 'sedmého dubna'],
    ['08.04.', '8.4.', '8', '4', 'osmého', 'dubna', 'osmého dubna'],
    ['09.04.', '9.4.', '9', '4', 'devátého', 'dubna', 'devátého dubna'],
    ['10.04.', '10.4.', '10', '4', 'desátého', 'dubna', 'desátého dubna'],
    ['11.04.', '11.4.', '11', '4', 'jedenáctého', 'dubna', 'jedenáctého dubna'],
    ['12.04.', '12.4.', '12', '4', 'dvanáctého', 'dubna', 'dvanáctého dubna'],
    ['13.04.', '13.4.', '13', '4', 'třináctého', 'dubna', 'třináctého dubna'],
    ['14.04.', '14.4.', '14', '4', 'čtrnáctého', 'dubna', 'čtrnáctého dubna'],
    ['15.04.', '15.4.', '15', '4', 'patnáctého', 'dubna', 'patnáctého dubna'],
    ['16.04.', '16.4.', '16', '4', 'šestnáctého', 'dubna', 'šestnáctého dubna'],
    ['17.04.', '17.4.', '17', '4', 'sedmnáctého', 'dubna', 'sedmnáctého dubna'],
    ['18.04.', '18.4.', '18', '4', 'osmnáctého', 'dubna', 'osmnáctého dubna'],
    ['19.04.', '19.4.', '19', '4', 'devatenáctého', 'dubna', 'devatenáctého dubna'],
    ['20.04.', '20.4.', '20', '4', 'dvacátého', 'dubna', 'dvacátého dubna'],
    ['21.04.', '21.4.', '21', '4', 'dvacátéhoprvního', 'dubna', 'dvacátéhoprvního dubna'],
    ['22.04.', '22.4.', '22', '4', 'dvacátéhodruhého', 'dubna', 'dvacátéhodruhého dubna'],
    ['23.04.', '23.4.', '23', '4', 'dvacátéhotřetího', 'dubna', 'dvacátéhotřetího dubna'],
    ['24.04.', '24.4.', '24', '4', 'dvacátéhočtvrtého', 'dubna', 'dvacátéhočtvrtého dubna'],
    ['25.04.', '25.4.', '25', '4', 'dvacátéhopátého', 'dubna', 'dvacátéhopátého dubna'],
    ['26.04.', '26.4.', '26', '4', 'dvacátéhošestého', 'dubna', 'dvacátéhošestého dubna'],
    ['27.04.', '27.4.', '27', '4', 'dvacátéhosedmého', 'dubna', 'dvacátéhosedmého dubna'],
    ['28.04.', '28.4.', '28', '4', 'dvacátéhoosmého', 'dubna', 'dvacátéhoosmého dubna'],
    ['29.04.', '29.4.', '29', '4', 'dvacátéhodevátého', 'dubna', 'dvacátéhodevátého dubna'],
    ['30.04.', '30.4.', '30', '4', 'třicátého', 'dubna', 'třicátého dubna'],
    ['01.05.', '1.5.', '1', '5', 'prvního', 'května', 'prvního května'],
    ['02.05.', '2.5.', '2', '5', 'druhého', 'května', 'druhého května'],
    ['03.05.', '3.5.', '3', '5', 'třetího', 'května', 'třetího května'],
    ['04.05.', '4.5.', '4', '5', 'čtvrtého', 'května', 'čtvrtého května'],
    ['05.05.', '5.5.', '5', '5', 'pátého', 'května', 'pátého května'],
    ['06.05.', '6.5.', '6', '5', 'šestého', 'května', 'šestého května'],
    ['07.05.', '7.5.', '7', '5', 'sedmého', 'května', 'sedmého května'],
    ['08.05.', '8.5.', '8', '5', 'osmého', 'května', 'osmého května'],
    ['09.05.', '9.5.', '9', '5', 'devátého', 'května', 'devátého května'],
    ['10.05.', '10.5.', '10', '5', 'desátého', 'května', 'desátého května'],
    ['11.05.', '11.5.', '11', '5', 'jedenáctého', 'května', 'jedenáctého května'],
    ['12.05.', '12.5.', '12', '5', 'dvanáctého', 'května', 'dvanáctého května'],
    ['13.05.', '13.5.', '13', '5', 'třináctého', 'května', 'třináctého května'],
    ['14.05.', '14.5.', '14', '5', 'čtrnáctého', 'května', 'čtrnáctého května'],
    ['15.05.', '15.5.', '15', '5', 'patnáctého', 'května', 'patnáctého května'],
    ['16.05.', '16.5.', '16', '5', 'šestnáctého', 'května', 'šestnáctého května'],
    ['17.05.', '17.5.', '17', '5', 'sedmnáctého', 'května', 'sedmnáctého května'],
    ['18.05.', '18.5.', '18', '5', 'osmnáctého', 'května', 'osmnáctého května'],
    ['19.05.', '19.5.', '19', '5', 'devatenáctého', 'května', 'devatenáctého května'],
    ['20.05.', '20.5.', '20', '5', 'dvacátého', 'května', 'dvacátého května'],
    ['21.05.', '21.5.', '21', '5', 'dvacátéhoprvního', 'května', 'dvacátéhoprvního května'],
    ['22.05.', '22.5.', '22', '5', 'dvacátéhodruhého', 'května', 'dvacátéhodruhého května'],
    ['23.05.', '23.5.', '23', '5', 'dvacátéhotřetího', 'května', 'dvacátéhotřetího května'],
    ['24.05.', '24.5.', '24', '5', 'dvacátéhočtvrtého', 'května', 'dvacátéhočtvrtého května'],
    ['25.05.', '25.5.', '25', '5', 'dvacátéhopátého', 'května', 'dvacátéhopátého května'],
    ['26.05.', '26.5.', '26', '5', 'dvacátéhošestého', 'května', 'dvacátéhošestého května'],
    ['27.05.', '27.5.', '27', '5', 'dvacátéhosedmého', 'května', 'dvacátéhosedmého května'],
    ['28.05.', '28.5.', '28', '5', 'dvacátéhoosmého', 'května', 'dvacátéhoosmého května'],
    ['29.05.', '29.5.', '29', '5', 'dvacátéhodevátého', 'května', 'dvacátéhodevátého května'],
    ['30.05.', '30.5.', '30', '5', 'třicátého', 'května', 'třicátého května'],
    ['31.05.', '31.5.', '31', '5', 'třicátéhoprvního', 'května', 'třicátéhoprvního května'],
    ['01.06.', '1.6.', '1', '6', 'prvního', 'června', 'prvního června'],
    ['02.06.', '2.6.', '2', '6', 'druhého', 'června', 'druhého června'],
    ['03.06.', '3.6.', '3', '6', 'třetího', 'června', 'třetího června'],
    ['04.06.', '4.6.', '4', '6', 'čtvrtého', 'června', 'čtvrtého června'],
    ['05.06.', '5.6.', '5', '6', 'pátého', 'června', 'pátého června'],
    ['06.06.', '6.6.', '6', '6', 'šestého', 'června', 'šestého června'],
    ['07.06.', '7.6.', '7', '6', 'sedmého', 'června', 'sedmého června'],
    ['08.06.', '8.6.', '8', '6', 'osmého', 'června', 'osmého června'],
    ['09.06.', '9.6.', '9', '6', 'devátého', 'června', 'devátého června'],
    ['10.06.', '10.6.', '10', '6', 'desátého', 'června', 'desátého června'],
    ['11.06.', '11.6.', '11', '6', 'jedenáctého', 'června', 'jedenáctého června'],
    ['12.06.', '12.6.', '12', '6', 'dvanáctého', 'června', 'dvanáctého června'],
    ['13.06.', '13.6.', '13', '6', 'třináctého', 'června', 'třináctého června'],
    ['14.06.', '14.6.', '14', '6', 'čtrnáctého', 'června', 'čtrnáctého června'],
    ['15.06.', '15.6.', '15', '6', 'patnáctého', 'června', 'patnáctého června'],
    ['16.06.', '16.6.', '16', '6', 'šestnáctého', 'června', 'šestnáctého června'],
    ['17.06.', '17.6.', '17', '6', 'sedmnáctého', 'června', 'sedmnáctého června'],
    ['18.06.', '18.6.', '18', '6', 'osmnáctého', 'června', 'osmnáctého června'],
    ['19.06.', '19.6.', '19', '6', 'devatenáctého', 'června', 'devatenáctého června'],
    ['20.06.', '20.6.', '20', '6', 'dvacátého', 'června', 'dvacátého června'],
    ['21.06.', '21.6.', '21', '6', 'dvacátéhoprvního', 'června', 'dvacátéhoprvního června'],
    ['22.06.', '22.6.', '22', '6', 'dvacátéhodruhého', 'června', 'dvacátéhodruhého června'],
    ['23.06.', '23.6.', '23', '6', 'dvacátéhotřetího', 'června', 'dvacátéhotřetího června'],
    ['24.06.', '24.6.', '24', '6', 'dvacátéhočtvrtého', 'června', 'dvacátéhočtvrtého června'],
    ['25.06.', '25.6.', '25', '6', 'dvacátéhopátého', 'června', 'dvacátéhopátého června'],
    ['26.06.', '26.6.', '26', '6', 'dvacátéhošestého', 'června', 'dvacátéhošestého června'],
    ['27.06.', '27.6.', '27', '6', 'dvacátéhosedmého', 'června', 'dvacátéhosedmého června'],
    ['28.06.', '28.6.', '28', '6', 'dvacátéhoosmého', 'června', 'dvacátéhoosmého června'],
    ['29.06.', '29.6.', '29', '6', 'dvacátéhodevátého', 'června', 'dvacátéhodevátého června'],
    ['30.06.', '30.6.', '30', '6', 'třicátého', 'června', 'třicátého června'],
    ['01.07.', '1.7.', '1', '7', 'prvního', 'července', 'prvního července'],
    ['02.07.', '2.7.', '2', '7', 'druhého', 'července', 'druhého července'],
    ['03.07.', '3.7.', '3', '7', 'třetího', 'července', 'třetího července'],
    ['04.07.', '4.7.', '4', '7', 'čtvrtého', 'července', 'čtvrtého července'],
    ['05.07.', '5.7.', '5', '7', 'pátého', 'července', 'pátého července'],
    ['06.07.', '6.7.', '6', '7', 'šestého', 'července', 'šestého července'],
    ['07.07.', '7.7.', '7', '7', 'sedmého', 'července', 'sedmého července'],
    ['08.07.', '8.7.', '8', '7', 'osmého', 'července', 'osmého července'],
    ['09.07.', '9.7.', '9', '7', 'devátého', 'července', 'devátého července'],
    ['10.07.', '10.7.', '10', '7', 'desátého', 'července', 'desátého července'],
    ['11.07.', '11.7.', '11', '7', 'jedenáctého', 'července', 'jedenáctého července'],
    ['12.07.', '12.7.', '12', '7', 'dvanáctého', 'července', 'dvanáctého července'],
    ['13.07.', '13.7.', '13', '7', 'třináctého', 'července', 'třináctého července'],
    ['14.07.', '14.7.', '14', '7', 'čtrnáctého', 'července', 'čtrnáctého července'],
    ['15.07.', '15.7.', '15', '7', 'patnáctého', 'července', 'patnáctého července'],
    ['16.07.', '16.7.', '16', '7', 'šestnáctého', 'července', 'šestnáctého července'],
    ['17.07.', '17.7.', '17', '7', 'sedmnáctého', 'července', 'sedmnáctého července'],
    ['18.07.', '18.7.', '18', '7', 'osmnáctého', 'července', 'osmnáctého července'],
    ['19.07.', '19.7.', '19', '7', 'devatenáctého', 'července', 'devatenáctého července'],
    ['20.07.', '20.7.', '20', '7', 'dvacátého', 'července', 'dvacátého července'],
    ['21.07.', '21.7.', '21', '7', 'dvacátéhoprvního', 'července', 'dvacátéhoprvního července'],
    ['22.07.', '22.7.', '22', '7', 'dvacátéhodruhého', 'července', 'dvacátéhodruhého července'],
    ['23.07.', '23.7.', '23', '7', 'dvacátéhotřetího', 'července', 'dvacátéhotřetího července'],
    ['24.07.', '24.7.', '24', '7', 'dvacátéhočtvrtého', 'července', 'dvacátéhočtvrtého července'],
    ['25.07.', '25.7.', '25', '7', 'dvacátéhopátého', 'července', 'dvacátéhopátého července'],
    ['26.07.', '26.7.', '26', '7', 'dvacátéhošestého', 'července', 'dvacátéhošestého července'],
    ['27.07.', '27.7.', '27', '7', 'dvacátéhosedmého', 'července', 'dvacátéhosedmého července'],
    ['28.07.', '28.7.', '28', '7', 'dvacátéhoosmého', 'července', 'dvacátéhoosmého července'],
    ['29.07.', '29.7.', '29', '7', 'dvacátéhodevátého', 'července', 'dvacátéhodevátého července'],
    ['30.07.', '30.7.', '30', '7', 'třicátého', 'července', 'třicátého července'],
    ['31.07.', '31.7.', '31', '7', 'třicátéhoprvního', 'července', 'třicátéhoprvního července'],
    ['01.08.', '1.8.', '1', '8', 'prvního', 'srpna', 'prvního srpna'],
    ['02.08.', '2.8.', '2', '8', 'druhého', 'srpna', 'druhého srpna'],
    ['03.08.', '3.8.', '3', '8', 'třetího', 'srpna', 'třetího srpna'],
    ['04.08.', '4.8.', '4', '8', 'čtvrtého', 'srpna', 'čtvrtého srpna'],
    ['05.08.', '5.8.', '5', '8', 'pátého', 'srpna', 'pátého srpna'],
    ['06.08.', '6.8.', '6', '8', 'šestého', 'srpna', 'šestého srpna'],
    ['07.08.', '7.8.', '7', '8', 'sedmého', 'srpna', 'sedmého srpna'],
    ['08.08.', '8.8.', '8', '8', 'osmého', 'srpna', 'osmého srpna'],
    ['09.08.', '9.8.', '9', '8', 'devátého', 'srpna', 'devátého srpna'],
    ['10.08.', '10.8.', '10', '8', 'desátého', 'srpna', 'desátého srpna'],
    ['11.08.', '11.8.', '11', '8', 'jedenáctého', 'srpna', 'jedenáctého srpna'],
    ['12.08.', '12.8.', '12', '8', 'dvanáctého', 'srpna', 'dvanáctého srpna'],
    ['13.08.', '13.8.', '13', '8', 'třináctého', 'srpna', 'třináctého srpna'],
    ['14.08.', '14.8.', '14', '8', 'čtrnáctého', 'srpna', 'čtrnáctého srpna'],
    ['15.08.', '15.8.', '15', '8', 'patnáctého', 'srpna', 'patnáctého srpna'],
    ['16.08.', '16.8.', '16', '8', 'šestnáctého', 'srpna', 'šestnáctého srpna'],
    ['17.08.', '17.8.', '17', '8', 'sedmnáctého', 'srpna', 'sedmnáctého srpna'],
    ['18.08.', '18.8.', '18', '8', 'osmnáctého', 'srpna', 'osmnáctého srpna'],
    ['19.08.', '19.8.', '19', '8', 'devatenáctého', 'srpna', 'devatenáctého srpna'],
    ['20.08.', '20.8.', '20', '8', 'dvacátého', 'srpna', 'dvacátého srpna'],
    ['21.08.', '21.8.', '21', '8', 'dvacátéhoprvního', 'srpna', 'dvacátéhoprvního srpna'],
    ['22.08.', '22.8.', '22', '8', 'dvacátéhodruhého', 'srpna', 'dvacátéhodruhého srpna'],
    ['23.08.', '23.8.', '23', '8', 'dvacátéhotřetího', 'srpna', 'dvacátéhotřetího srpna'],
    ['24.08.', '24.8.', '24', '8', 'dvacátéhočtvrtého', 'srpna', 'dvacátéhočtvrtého srpna'],
    ['25.08.', '25.8.', '25', '8', 'dvacátéhopátého', 'srpna', 'dvacátéhopátého srpna'],
    ['26.08.', '26.8.', '26', '8', 'dvacátéhošestého', 'srpna', 'dvacátéhošestého srpna'],
    ['27.08.', '27.8.', '27', '8', 'dvacátéhosedmého', 'srpna', 'dvacátéhosedmého srpna'],
    ['28.08.', '28.8.', '28', '8', 'dvacátéhoosmého', 'srpna', 'dvacátéhoosmého srpna'],
    ['29.08.', '29.8.', '29', '8', 'dvacátéhodevátého', 'srpna', 'dvacátéhodevátého srpna'],
    ['30.08.', '30.8.', '30', '8', 'třicátého', 'srpna', 'třicátého srpna'],
    ['31.08.', '31.8.', '31', '8', 'třicátéhoprvního', 'srpna', 'třicátéhoprvního srpna'],
    ['01.09.', '1.9.', '1', '9', 'prvního', 'září', 'prvního září'],
    ['02.09.', '2.9.', '2', '9', 'druhého', 'září', 'druhého září'],
    ['03.09.', '3.9.', '3', '9', 'třetího', 'září', 'třetího září'],
    ['04.09.', '4.9.', '4', '9', 'čtvrtého', 'září', 'čtvrtého září'],
    ['05.09.', '5.9.', '5', '9', 'pátého', 'září', 'pátého září'],
    ['06.09.', '6.9.', '6', '9', 'šestého', 'září', 'šestého září'],
    ['07.09.', '7.9.', '7', '9', 'sedmého', 'září', 'sedmého září'],
    ['08.09.', '8.9.', '8', '9', 'osmého', 'září', 'osmého září'],
    ['09.09.', '9.9.', '9', '9', 'devátého', 'září', 'devátého září'],
    ['10.09.', '10.9.', '10', '9', 'desátého', 'září', 'desátého září'],
    ['11.09.', '11.9.', '11', '9', 'jedenáctého', 'září', 'jedenáctého září'],
    ['12.09.', '12.9.', '12', '9', 'dvanáctého', 'září', 'dvanáctého září'],
    ['13.09.', '13.9.', '13', '9', 'třináctého', 'září', 'třináctého září'],
    ['14.09.', '14.9.', '14', '9', 'čtrnáctého', 'září', 'čtrnáctého září'],
    ['15.09.', '15.9.', '15', '9', 'patnáctého', 'září', 'patnáctého září'],
    ['16.09.', '16.9.', '16', '9', 'šestnáctého', 'září', 'šestnáctého září'],
    ['17.09.', '17.9.', '17', '9', 'sedmnáctého', 'září', 'sedmnáctého září'],
    ['18.09.', '18.9.', '18', '9', 'osmnáctého', 'září', 'osmnáctého září'],
    ['19.09.', '19.9.', '19', '9', 'devatenáctého', 'září', 'devatenáctého září'],
    ['20.09.', '20.9.', '20', '9', 'dvacátého', 'září', 'dvacátého září'],
    ['21.09.', '21.9.', '21', '9', 'dvacátéhoprvního', 'září', 'dvacátéhoprvního září'],
    ['22.09.', '22.9.', '22', '9', 'dvacátéhodruhého', 'září', 'dvacátéhodruhého září'],
    ['23.09.', '23.9.', '23', '9', 'dvacátéhotřetího', 'září', 'dvacátéhotřetího září'],
    ['24.09.', '24.9.', '24', '9', 'dvacátéhočtvrtého', 'září', 'dvacátéhočtvrtého září'],
    ['25.09.', '25.9.', '25', '9', 'dvacátéhopátého', 'září', 'dvacátéhopátého září'],
    ['26.09.', '26.9.', '26', '9', 'dvacátéhošestého', 'září', 'dvacátéhošestého září'],
    ['27.09.', '27.9.', '27', '9', 'dvacátéhosedmého', 'září', 'dvacátéhosedmého září'],
    ['28.09.', '28.9.', '28', '9', 'dvacátéhoosmého', 'září', 'dvacátéhoosmého září'],
    ['29.09.', '29.9.', '29', '9', 'dvacátéhodevátého', 'září', 'dvacátéhodevátého září'],
    ['30.09.', '30.9.', '30', '9', 'třicátého', 'září', 'třicátého září'],
    ['01.10.', '1.10.', '1', '10', 'prvního', 'října', 'prvního října'],
    ['02.10.', '2.10.', '2', '10', 'druhého', 'října', 'druhého října'],
    ['03.10.', '3.10.', '3', '10', 'třetího', 'října', 'třetího října'],
    ['04.10.', '4.10.', '4', '10', 'čtvrtého', 'října', 'čtvrtého října'],
    ['05.10.', '5.10.', '5', '10', 'pátého', 'října', 'pátého října'],
    ['06.10.', '6.10.', '6', '10', 'šestého', 'října', 'šestého října'],
    ['07.10.', '7.10.', '7', '10', 'sedmého', 'října', 'sedmého října'],
    ['08.10.', '8.10.', '8', '10', 'osmého', 'října', 'osmého října'],
    ['09.10.', '9.10.', '9', '10', 'devátého', 'října', 'devátého října'],
    ['10.10.', '10.10.', '10', '10', 'desátého', 'října', 'desátého října'],
    ['11.10.', '11.10.', '11', '10', 'jedenáctého', 'října', 'jedenáctého října'],
    ['12.10.', '12.10.', '12', '10', 'dvanáctého', 'října', 'dvanáctého října'],
    ['13.10.', '13.10.', '13', '10', 'třináctého', 'října', 'třináctého října'],
    ['14.10.', '14.10.', '14', '10', 'čtrnáctého', 'října', 'čtrnáctého října'],
    ['15.10.', '15.10.', '15', '10', 'patnáctého', 'října', 'patnáctého října'],
    ['16.10.', '16.10.', '16', '10', 'šestnáctého', 'října', 'šestnáctého října'],
    ['17.10.', '17.10.', '17', '10', 'sedmnáctého', 'října', 'sedmnáctého října'],
    ['18.10.', '18.10.', '18', '10', 'osmnáctého', 'října', 'osmnáctého října'],
    ['19.10.', '19.10.', '19', '10', 'devatenáctého', 'října', 'devatenáctého října'],
    ['20.10.', '20.10.', '20', '10', 'dvacátého', 'října', 'dvacátého října'],
    ['21.10.', '21.10.', '21', '10', 'dvacátéhoprvního', 'října', 'dvacátéhoprvního října'],
    ['22.10.', '22.10.', '22', '10', 'dvacátéhodruhého', 'října', 'dvacátéhodruhého října'],
    ['23.10.', '23.10.', '23', '10', 'dvacátéhotřetího', 'října', 'dvacátéhotřetího října'],
    ['24.10.', '24.10.', '24', '10', 'dvacátéhočtvrtého', 'října', 'dvacátéhočtvrtého října'],
    ['25.10.', '25.10.', '25', '10', 'dvacátéhopátého', 'října', 'dvacátéhopátého října'],
    ['26.10.', '26.10.', '26', '10', 'dvacátéhošestého', 'října', 'dvacátéhošestého října'],
    ['27.10.', '27.10.', '27', '10', 'dvacátéhosedmého', 'října', 'dvacátéhosedmého října'],
    ['28.10.', '28.10.', '28', '10', 'dvacátéhoosmého', 'října', 'dvacátéhoosmého října'],
    ['29.10.', '29.10.', '29', '10', 'dvacátéhodevátého', 'října', 'dvacátéhodevátého října'],
    ['30.10.', '30.10.', '30', '10', 'třicátého', 'října', 'třicátého října'],
    ['31.10.', '31.10.', '31', '10', 'třicátéhoprvního', 'října', 'třicátéhoprvního října'],
    ['01.11.', '1.11.', '1', '11', 'prvního', 'listopadu', 'prvního listopadu'],
    ['02.11.', '2.11.', '2', '11', 'druhého', 'listopadu', 'druhého listopadu'],
    ['03.11.', '3.11.', '3', '11', 'třetího', 'listopadu', 'třetího listopadu'],
    ['04.11.', '4.11.', '4', '11', 'čtvrtého', 'listopadu', 'čtvrtého listopadu'],
    ['05.11.', '5.11.', '5', '11', 'pátého', 'listopadu', 'pátého listopadu'],
    ['06.11.', '6.11.', '6', '11', 'šestého', 'listopadu', 'šestého listopadu'],
    ['07.11.', '7.11.', '7', '11', 'sedmého', 'listopadu', 'sedmého listopadu'],
    ['08.11.', '8.11.', '8', '11', 'osmého', 'listopadu', 'osmého listopadu'],
    ['09.11.', '9.11.', '9', '11', 'devátého', 'listopadu', 'devátého listopadu'],
    ['10.11.', '10.11.', '10', '11', 'desátého', 'listopadu', 'desátého listopadu'],
    ['11.11.', '11.11.', '11', '11', 'jedenáctého', 'listopadu', 'jedenáctého listopadu'],
    ['12.11.', '12.11.', '12', '11', 'dvanáctého', 'listopadu', 'dvanáctého listopadu'],
    ['13.11.', '13.11.', '13', '11', 'třináctého', 'listopadu', 'třináctého listopadu'],
    ['14.11.', '14.11.', '14', '11', 'čtrnáctého', 'listopadu', 'čtrnáctého listopadu'],
    ['15.11.', '15.11.', '15', '11', 'patnáctého', 'listopadu', 'patnáctého listopadu'],
    ['16.11.', '16.11.', '16', '11', 'šestnáctého', 'listopadu', 'šestnáctého listopadu'],
    ['17.11.', '17.11.', '17', '11', 'sedmnáctého', 'listopadu', 'sedmnáctého listopadu'],
    ['18.11.', '18.11.', '18', '11', 'osmnáctého', 'listopadu', 'osmnáctého listopadu'],
    ['19.11.', '19.11.', '19', '11', 'devatenáctého', 'listopadu', 'devatenáctého listopadu'],
    ['20.11.', '20.11.', '20', '11', 'dvacátého', 'listopadu', 'dvacátého listopadu'],
    ['21.11.', '21.11.', '21', '11', 'dvacátéhoprvního', 'listopadu', 'dvacátéhoprvního listopadu'],
    ['22.11.', '22.11.', '22', '11', 'dvacátéhodruhého', 'listopadu', 'dvacátéhodruhého listopadu'],
    ['23.11.', '23.11.', '23', '11', 'dvacátéhotřetího', 'listopadu', 'dvacátéhotřetího listopadu'],
    [
      '24.11.',
      '24.11.',
      '24',
      '11',
      'dvacátéhočtvrtého',
      'listopadu',
      'dvacátéhočtvrtého listopadu'
    ],
    ['25.11.', '25.11.', '25', '11', 'dvacátéhopátého', 'listopadu', 'dvacátéhopátého listopadu'],
    ['26.11.', '26.11.', '26', '11', 'dvacátéhošestého', 'listopadu', 'dvacátéhošestého listopadu'],
    ['27.11.', '27.11.', '27', '11', 'dvacátéhosedmého', 'listopadu', 'dvacátéhosedmého listopadu'],
    ['28.11.', '28.11.', '28', '11', 'dvacátéhoosmého', 'listopadu', 'dvacátéhoosmého listopadu'],
    [
      '29.11.',
      '29.11.',
      '29',
      '11',
      'dvacátéhodevátého',
      'listopadu',
      'dvacátéhodevátého listopadu'
    ],
    ['30.11.', '30.11.', '30', '11', 'třicátého', 'listopadu', 'třicátého listopadu'],
    ['01.12.', '1.12.', '1', '12', 'prvního', 'prosince', 'prvního prosince'],
    ['02.12.', '2.12.', '2', '12', 'druhého', 'prosince', 'druhého prosince'],
    ['03.12.', '3.12.', '3', '12', 'třetího', 'prosince', 'třetího prosince'],
    ['04.12.', '4.12.', '4', '12', 'čtvrtého', 'prosince', 'čtvrtého prosince'],
    ['05.12.', '5.12.', '5', '12', 'pátého', 'prosince', 'pátého prosince'],
    ['06.12.', '6.12.', '6', '12', 'šestého', 'prosince', 'šestého prosince'],
    ['07.12.', '7.12.', '7', '12', 'sedmého', 'prosince', 'sedmého prosince'],
    ['08.12.', '8.12.', '8', '12', 'osmého', 'prosince', 'osmého prosince'],
    ['09.12.', '9.12.', '9', '12', 'devátého', 'prosince', 'devátého prosince'],
    ['10.12.', '10.12.', '10', '12', 'desátého', 'prosince', 'desátého prosince'],
    ['11.12.', '11.12.', '11', '12', 'jedenáctého', 'prosince', 'jedenáctého prosince'],
    ['12.12.', '12.12.', '12', '12', 'dvanáctého', 'prosince', 'dvanáctého prosince'],
    ['13.12.', '13.12.', '13', '12', 'třináctého', 'prosince', 'třináctého prosince'],
    ['14.12.', '14.12.', '14', '12', 'čtrnáctého', 'prosince', 'čtrnáctého prosince'],
    ['15.12.', '15.12.', '15', '12', 'patnáctého', 'prosince', 'patnáctého prosince'],
    ['16.12.', '16.12.', '16', '12', 'šestnáctého', 'prosince', 'šestnáctého prosince'],
    ['17.12.', '17.12.', '17', '12', 'sedmnáctého', 'prosince', 'sedmnáctého prosince'],
    ['18.12.', '18.12.', '18', '12', 'osmnáctého', 'prosince', 'osmnáctého prosince'],
    ['19.12.', '19.12.', '19', '12', 'devatenáctého', 'prosince', 'devatenáctého prosince'],
    ['20.12.', '20.12.', '20', '12', 'dvacátého', 'prosince', 'dvacátého prosince'],
    ['21.12.', '21.12.', '21', '12', 'dvacátéhoprvního', 'prosince', 'dvacátéhoprvního prosince'],
    ['22.12.', '22.12.', '22', '12', 'dvacátéhodruhého', 'prosince', 'dvacátéhodruhého prosince'],
    ['23.12.', '23.12.', '23', '12', 'dvacátéhotřetího', 'prosince', 'dvacátéhotřetího prosince'],
    ['24.12.', '24.12.', '24', '12', 'dvacátéhočtvrtého', 'prosince', 'dvacátéhočtvrtého prosince'],
    ['25.12.', '25.12.', '25', '12', 'dvacátéhopátého', 'prosince', 'dvacátéhopátého prosince'],
    ['26.12.', '26.12.', '26', '12', 'dvacátéhošestého', 'prosince', 'dvacátéhošestého prosince'],
    ['27.12.', '27.12.', '27', '12', 'dvacátéhosedmého', 'prosince', 'dvacátéhosedmého prosince'],
    ['28.12.', '28.12.', '28', '12', 'dvacátéhoosmého', 'prosince', 'dvacátéhoosmého prosince'],
    ['29.12.', '29.12.', '29', '12', 'dvacátéhodevátého', 'prosince', 'dvacátéhodevátého prosince'],
    ['30.12.', '30.12.', '30', '12', 'třicátého', 'prosince', 'třicátého prosince'],
    ['31.12.', '31.12.', '31', '12', 'třicátéhoprvního', 'prosince', 'třicátéhoprvního prosince']
  ]
}
